import React from 'react';

interface ProgressChartProps {
  completed: number;
  total: number;
}

export default function ProgressChart({ completed, total }: ProgressChartProps) {
  const percentage = Math.round((completed / total) * 100);

  return (
    <div className="flex items-center">
      <div className="relative w-24 h-24">
        <svg className="w-full h-full" viewBox="0 0 36 36">
          {/* Background circle */}
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="#E5E7EB"
            strokeWidth="3"
          />
          {/* Progress circle */}
          <path
            d="M18 2.0845
              a 15.9155 15.9155 0 0 1 0 31.831
              a 15.9155 15.9155 0 0 1 0 -31.831"
            fill="none"
            stroke="#4F46E5"
            strokeWidth="3"
            strokeDasharray={`${percentage}, 100`}
          />
          {/* Percentage text */}
          <text
            x="18"
            y="20.35"
            className="text-3xl font-bold"
            textAnchor="middle"
            fill="#111827"
          >
            {percentage}%
          </text>
        </svg>
      </div>
      <div className="ml-4">
        <p className="text-sm font-medium text-gray-500">Progress</p>
        <p className="text-lg font-semibold text-gray-900">
          {completed} / {total} Completed
        </p>
      </div>
    </div>
  );
}